export * from './content-status-badge.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/content-status-badge/index.ts